<template>
  <b-container class="pt-3">
    <b-button v-print="'#print-nondisclosure'">列印</b-button>
    <print-page />
  </b-container>
</template>
<script>
import print from "vue-print-nb";
import PrintPage from "@/components/print/nondisclosure";
export default {
  name: "NonDisclosurePrint",
  components: { PrintPage },
  directives: {
    print,
  },
  mounted() {},
  methods: {},
};
</script>

